module.exports = __webpack_public_path__ + "static/img/9.065a01c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/9.png
// module id = a+Xx
// module chunks = 0